module.exports = __webpack_public_path__ + "static/media/pre-filled-syringe.a8522aaa.svg";